import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {useStores} from "../../../stores/Context";
import MIMessage from "./MIMessage";
import MIMessimage from "./MIMessimage";
import MIImage from "./MIImage";
import MIPdf from "./MIPdf";
import MIYoutube from "./MIYoutube";
import {useParams} from "react-router-dom";
import SidebarWidgets from "../../SidebarWidgets/SidebarWidgets";

/*
 * Ajout PEP
 */
import Picker from "emoji-picker-react";
import {Mention, MentionsInput} from 'react-mentions';
import {v4 as uuidv4} from "uuid";
import BtnPrimary from "../../../boiteAOutils/BtnPrimary";
import BtnSecondary from "../../../boiteAOutils/BtnSecondary";
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import Checkbox from "../../../boiteAOutils/Checkbox";
import BtnSvg from "../../../boiteAOutils/BtnSvg";
import CorbeilleSvg from "../../../boiteAOutils/SVG/CorbeilleSvg";
import CrayonSvg from "../../../boiteAOutils/SVG/CrayonSvg";
/* Fin */

/*
 * Soketi
 */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";
import axiosUserInstance from "../../../axiosUser";
import EditableText from "../../../boiteAOutils/texte/EditableText";
import InitialeCircle from "../../../boiteAOutils/texte/InitialeCircle";

const ListeMessagesInterServices = observer(() => {
    const {ent} = useParams();
    const {
        widgetStore,
        sidebarWidgetStore,
        messageInterServicesStore,
        bibliothequeImagesStore,
    } = useStores();
    const [listMessagesInterServices, setListMessagesInterServices] = useState([]);
    const [listMessagesInterServicesArchives, setListMessagesInterServicesArchives] = useState([]);
    /*
    * Ajout PEP
    */
    const [emojiPickerState, SetEmojiPicker] = useState(false);
    const [message, SetMessage] = useState("");
    const [title, SetTitle] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedUpdateImage, setSelectedUpdateImage] = useState(null);
    const [pinned, setPinned] = useState(false);
    const [totemList, setTotemList] = useState([]);
    const [errFormAdd, setErrFormAdd] = useState({
        message: "",
        type: null
    })
    const [showUpdate, setShowUpdate] = useState(messageInterServicesStore.showEdit);
    const [datasUpdate, setDatasUpdate] = useState({});
    const [showModalSuppr, setShowModalSuppr] = useState(false);
    const [showModalSupprComment, setShowModalSupprComment] = useState(false);

    const axiosEntrepriseInstance = createAxiosEntrepriseInstance(ent);

    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();
    const hasBibliothequeImages = Array.isArray(entrepriseInfos.phidgetsActives) && entrepriseInfos.phidgetsActives.includes("WidgetBibliothequeImages");

    /*
     * Soketi
     */
    window.Pusher = Pusher;

    useEffect(() => {
        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WS_KEY,
            secret: process.env.REACT_APP_WS_SECRET,
            wsHost: process.env.REACT_APP_WS_URL,
            wsPort: 6001,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu',
        });

        const connectionEvents = ['connected', 'disconnected', 'connecting', 'reconnecting', 'error'];
        connectionEvents.forEach(event => {
            echo.connector.pusher.connection.bind(event, (err) => {
                console.log(`MInterne_WS::${event}`);
            });
        });


        // Evenement pour mettre à jour la liste des messages interne + messages archivé.
        echo.channel(widgetStore.idTotem + '-MInterne_refreshDatas')
            .listen('MInterne\\MInterneRefreshEvent', (e) => {
                console.log('WS::MInterneRefreshEvent');
                recupListMessagesInterServices();
                recupListMessagesInterServicesArchives();
            });

        echo.channel(widgetStore.idTotem + '-MInterne_refreshArchiveDatas')
            .listen('MInterne\\MInterneRefreshArchiveEvent', (e) => {
                console.log('WS::MInterneRefreshArchiveEvent');
                recupListMessagesInterServicesArchives();
            });

        // Cleanup function to unsubscribe when the component unmounts
        return () => {
            echo.disconnect();
        };
    }, []);

    const inputStyle = {
        width: '95%',
        minHeight: '160px',
        backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
        control: {
            backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
            fontSize: 16,
        },
        '&multiLine': {
            control: {
                minHeight: 60,
            },
            highlighter: {
                padding: 9,
                border: '1px solid transparent',
            },
            input: {
                padding: 9,
                border: '1px solid transparent',
            },
        },
        '&singleLine': {
            display: 'inline-block',
            width: 280,
            highlighter: {
                padding: 1,
                border: '2px inset transparent',
            },
            input: {
                padding: 1,
                border: '2px inset',
            },
        },
        suggestions: {
            list: {
                backgroundColor: 'white',
                border: '1px solid rgba(0,0,0,0.15)',
                fontSize: 16,
            },
            item: {
                padding: '5px 15px',
                borderBottom: '1px solid rgba(0,0,0,0.15)',
                '&focused': {
                    backgroundColor: '#cee4e5',
                },
            },
        },
    };

    // Initialisation de la liste des totems, pour les @mentions
    useEffect(() => {
        messageInterServicesStore.getAllTotem(ent).then((res) => {
            setTotemList(res);
        })
    }, []);

    useEffect(() => {
        if (messageInterServicesStore.showEdit !== showUpdate) {
            setShowUpdate(messageInterServicesStore.showEdit);
        }
    }, [messageInterServicesStore.showEdit]);

    // Au changement de title, verifier qu'il fait moins de 50 caracteres
    useEffect(() => {
        if (title.length > 50) {
            // Ne pas insérer le caractère
            SetTitle(title.slice(0, 51));
            setErrFormAdd({
                message: "Le titre ne doit pas dépasser 50 caractères.",
                type: 'error'
            });
        } else {
            setErrFormAdd({
                message: "",
                type: null
            });
        }
    }, [title]);

    // Gestion de l'affichage des erreurs du formulaire d'ajout de message
    useEffect(() => {
        if (errFormAdd.message !== "") {
            setTimeout(() => {
                setErrFormAdd({
                    message: "",
                    type: null
                });
            }, 5000);
        }
    }, [message]);

    // Gestion de l'input files / image
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            // Test si le fichier est une image
            if (img.type.startsWith("image/")) {
                setSelectedImage(URL.createObjectURL(img));
                setErrFormAdd({
                    message: "",
                    type: null
                });
                bibliothequeImagesStore.onResetImageModule();
            } else {
                setErrFormAdd({
                    message: "Le fichier sélectionné n'est pas une image.",
                    type: 'error'
                });
                setSelectedImage(null);
            }
        }
    }
    console.log('dataupdated', datasUpdate);
    const handleImageUpdateChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            // Test si le fichier est une image
            if (img.type.startsWith("image/")) {
                setSelectedUpdateImage(URL.createObjectURL(img));
                setErrFormAdd({
                    message: "",
                    type: null
                });
                setDatasUpdate({
                    ...datasUpdate,
                    configurable: {
                        ...datasUpdate.configurable,
                        messimage: "imgUpdated"
                    }
                })
            } else {
                setErrFormAdd({
                    message: "Le fichier sélectionné n'est pas une image.",
                    type: 'error'
                });
                setSelectedUpdateImage(null);
            }
        }
    }

    // Gestion de la librairie d'emojis dans le formulaire
    let emojiPicker;
    if (emojiPickerState) {
        emojiPicker = (
            <div className={'absolute right-1'} style={selectedImage ? {bottom: '3em'} : {}}>
                <Picker
                    searchDisabled={true}
                    autoFocusSearch={false}
                    reactionsDefaultOpen={false}
                    allowExpandReactions={true}
                    lazyLoadEmojis={true}
                    emojiStyle={'native'}
                    className={"emojiPicker"}
                    onEmojiClick={(emojiObject, event) => {
                        SetMessage(prevMessage => {
                            const cursorPosition = document.getElementById('messageInput').selectionStart;
                            return prevMessage.slice(0, cursorPosition) + emojiObject.emoji + prevMessage.slice(cursorPosition);
                        });
                    }}
                />
            </div>
        );
    }
    let emojiPickerUpdate;
    if (emojiPickerState) {
        emojiPickerUpdate = (
            <div className={'absolute right-1'} style={selectedImage ? {bottom: '3em'} : {}}>
                <Picker
                    searchDisabled={true}
                    autoFocusSearch={false}
                    reactionsDefaultOpen={false}
                    allowExpandReactions={true}
                    lazyLoadEmojis={true}
                    emojiStyle={'native'}
                    className={"emojiPicker"}
                    onEmojiClick={(emojiObject, event) => {
                        setDatasUpdate(prevDatasUpdate => {
                            const cursorPosition = document.getElementById('messageInputUpdate').selectionStart;
                            return {
                                ...prevDatasUpdate,
                                configurable: {
                                    ...prevDatasUpdate.configurable,
                                    contenu: prevDatasUpdate.configurable.contenu.slice(0, cursorPosition) + emojiObject.emoji + prevDatasUpdate.configurable.contenu.slice(cursorPosition)
                                }
                            };
                        });
                    }}
                />
            </div>
        );
    }

    // Gestion de l'affichage de la modal d'ajout de message
    const handleCloseModalAdd = () => {
        messageInterServicesStore.handleCloseAdd();
        bibliothequeImagesStore.handleCloseModuleImage();
        bibliothequeImagesStore.onResetImageModule();
    };
    /*
    * fin
    */

    useEffect(() => {
        recupListMessagesInterServices();
    }, []);

    useEffect(() => {
        recupListMessagesInterServicesArchives();
    }, [messageInterServicesStore.showArchive]);

    const recupListMessagesInterServices = () => {
        axiosEntrepriseInstance.get('/api/MI/ListeMiConfigurationTotem/' + widgetStore.idTotem + "/EN LIGNE")
            .then((res) => {
                setListMessagesInterServices(res.data);
            });
    }

    const recupListMessagesInterServicesArchives = () => {
        axiosEntrepriseInstance.get('/api/MI/ListeMiConfigurationTotem/' + widgetStore.idTotem + "/ARCHIVE")
            .then((res) => {
                setListMessagesInterServicesArchives(res.data);
            });
    }


    const toggleMISQuart = (configuration_id, quart_id) => {
        axiosEntrepriseInstance.post('/api/MI/toggleConfigurationQuart/' + configuration_id + "/" + quart_id, {}).then((res) => {
            recupListMessagesInterServices();
        })
    }

    const supprimerMIDuTotem = (configuration_id) => {
        axiosEntrepriseInstance.post('/api/MI/supprimerConfigurationTotem/' + configuration_id + "/" + widgetStore.idTotem, {}).then((res) => {
            recupListMessagesInterServices();
        })
    }

    const restaurerMIDuTotem = (configuration_id) => {
        axiosEntrepriseInstance.post('/api/MI/restaurerConfigurationTotem/' + configuration_id + "/" + widgetStore.idTotem, {}).then((res) => {
            recupListMessagesInterServices();
            recupListMessagesInterServicesArchives();
        })
    }

    const PostHeader = ({isPinned, idConf, title, name, createdAt, updatedAt, configurable, showDotsMenu = false}) => {
        const [showActions, setShowActions] = useState(false);

        const handleTogglePinned = (idConf, idTotem) => {
            // apiToggleIsPinned(MIConfiguration $configuration, Totem $totem)
            axiosEntrepriseInstance.post('/api/MI/togglePinned/' + idConf + "/" + idTotem, {})
                .then((res) => {
                    recupListMessagesInterServices();
                }).catch((e) => {
                console.log("Erreur lors de la modification de l'épinglage du message.");
                alert(e.response.data);
            });
        }

        // Calculer le temps passé depuis la création et la dernière modification.
        // const createdTimePassed = new Date() - new Date(createdAt);
        // const createdReadableFormat = convertTimeToReadableFormat(createdTimePassed);
        //
        // const updatedTimePassed = new Date() - new Date(updatedAt);
        // const updatedReadableFormat = convertTimeToReadableFormat(updatedTimePassed);

        /*
         * Avoir la date BDD sous la forme "4 avril 2024"
         */
        const dateObj = new Date(createdAt);

        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const formattedDate = dateObj.toLocaleDateString('fr-FR', options);

        const handleMessActions = () => {
            setShowActions(!showActions);
        }

        return (
            <>
                <div className="flex items-center justify-between p-2 mb-2 mt-3">
                    <div className="flex items-center space-x-2">
                        <div>
                            <div className="posterName">{name}</div>
                            {/*<div className="text-xs text-gray-500">*/}
                            {/*    {createdReadableFormat} {createdTimePassed !== updatedTimePassed ? `• Modifié il y a ${updatedReadableFormat}` : ""}*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="flex items-center relative">
                        <div className="titlePost__container">{title}</div>
                        {showDotsMenu && (
                            <>
                                <BtnSvg svg={"trois_points"} height={"40"} width={"40"} onClick={handleMessActions}/>

                                {showActions ? (
                                    <div className={"consigneCardContentActionsContent z-50 absolute top-0 -right-48"}>
                                        <div className={"consigneCardContentActionsItems"} onClick={() => {
                                            supprimerMIDuTotem(idConf)
                                        }}>
                                            <CorbeilleSvg/>
                                            <span className={"consigneCardContentActionsItemsName"}>Archiver</span>
                                        </div>
                                        <div className={"consigneCardContentActionsItems"} onClick={() => {
                                            setDatasUpdate({
                                                isPinned,
                                                idConf,
                                                title,
                                                name,
                                                createdAt,
                                                updatedAt,
                                                formattedDate,
                                                configurable
                                            });
                                            messageInterServicesStore.showEdit = true;
                                        }}>
                                            <CrayonSvg/>
                                            <span
                                                className={"consigneCardContentActionsItemsName"}>Modifier</span>
                                        </div>
                                    </div>
                                ) : ''}
                            </>
                        )}
                    </div>
                </div>
                <div className={"date__container"}>
                    {showDotsMenu ? (isPinned ? (
                        <BtnSvg svg={"ancrage"} onClick={() => handleTogglePinned(idConf, widgetStore.idTotem)}
                                width="28" height="38"/>
                    ) : (
                        <BtnSvg svg={"ancrage"} onClick={() => handleTogglePinned(idConf, widgetStore.idTotem)}
                                width="28" height="38" couleur={"#A8B0B3"}/>
                    )) : (
                        <span className={"postDate"} style={{
                            color: "var(--icon-dark-text, #70787B)"
                        }}>
                            Création le&nbsp;
                        </span>
                    )}
                    <span className={`postDate`}>{formattedDate}</span>
                </div>
            </>
        );
    };

    const PostFooter = ({id, count, reactions, coms, showLikeButton = true}) => {
        const [showCommentInput, setShowCommentInput] = useState(false);
        const [showPicker, setShowPicker] = useState(false);
        const [howManyReaction, setHowManyReaction] = useState(count);
        const [newComment, setNewComment] = useState("");

        console.log('comments', coms);

        const handleAddComment = () => {
            axiosUserInstance.post('/api/MI/AddComment/' + id + "/" + widgetStore.idTotem, {
                comment: newComment,
                configuration_id: id
            })
                .then((res) => {
                    setNewComment("");
                    recupListMessagesInterServices();
                });
        }

        // Fonction pour convertir le temps passé en format lisible.
        // ex : il y à 14 jours
        const convertTimeToReadableFormat = (dateHeure) => {
            const timePassed = new Date() - new Date(dateHeure);
            const hoursPassed = Math.floor(timePassed / 1000 / 60 / 60);
            if (hoursPassed < 1) {
                const minutes = Math.floor(timePassed / 1000 / 60);
                return `${minutes} minute${minutes > 1 ? 's' : ''}`;
            } else if (hoursPassed < 24) {
                return `${hoursPassed} heure${hoursPassed > 1 ? 's' : ''}`;
            } else if (hoursPassed < 24 * 30) {
                const days = Math.floor(hoursPassed / 24);
                return `${days} jour${days > 1 ? 's' : ''}`;
            } else if (hoursPassed < 24 * 30 * 12) {
                const months = Math.floor(hoursPassed / (24 * 30));
                return `${months} mois`;
            } else {
                const years = Math.floor(hoursPassed / (24 * 30 * 12));
                return `${years} an${years > 1 ? 's' : ''}`;
            }
        }

        const emojiToText = {
            "👍": "J'aime",
            "❤️": "J'adore",
            "😃": "Content",
            "😢": "Triste",
            "🙏": "Reconnaissant",
            "👎": "Je n'aime pas",
            "😡": "Colère",
        };
        const emojiToColor = {
            "👍": "text-blue-500",
            "❤️": "text-red-500",
            "😃": "text-yellow-500",
            "😢": "text-blue-500",
            "🙏": "text-purple-500",
            "👎": "text-gray-500",
            "😡": "text-orange-500",
        };

        const currentReaction = reactions.find(reaction => reaction.who === widgetStore.idTotem)?.reaction;
        const isReactionFromCurrentTotem = Boolean(currentReaction);

        const sendReaction = (reaction) => {
            axiosEntrepriseInstance.post('/api/MI/reaction/' + id + "/" + widgetStore.idTotem, {
                reaction,
                configuration_id: id
            })
                .then((res) => {
                    setShowPicker(false);
                    setHowManyReaction(res.data.count);
                    recupListMessagesInterServices();
                }).catch(() => setShowPicker(false));
        }

        return (
            <div className={'text-gray-600 w-full  rounded-b-xl grid grid-cols-2'}>
                <div className={'text-left px-3 mb-3'}>
                    {howManyReaction > 0 && (
                        <div className={''} style={{display: 'inline-block'}}>
                            <div className={'relative left-6'}>
                                {Object.entries(reactions.reduce((acc, {reaction}) => ({
                                    ...acc,
                                    [reaction]: (acc[reaction] || 0) + 1
                                }), {})).sort((a, b) => b[1] - a[1]).slice(0, 3).map(([reaction], index) => (
                                    <div key={index} style={{position: 'absolute', left: `${index * 17}px`}}>
                                        {reaction}
                                    </div>
                                ))}
                            </div>
                            {howManyReaction}
                        </div>
                    )}
                </div>

                <div className={'text-right px-3'}>
                    {coms?.length > 0 && (
                        <>{coms.length} commentaires</>
                    )}
                </div>

                <div
                    className={`${isReactionFromCurrentTotem && emojiToColor[currentReaction]}  relative inline-block border-r border-gray-300 bg-gray-100`}>
                    {showLikeButton && (
                        <button onClick={() => setShowPicker(!showPicker)}
                                className={`flex items-center mx-auto emoji-button like_container`}>
                            {isReactionFromCurrentTotem ? `${currentReaction} ${emojiToText[currentReaction]}` : (
                                <div className={"likeLibelle__container"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5}
                                         stroke="currentColor" className="w-6 h-6 mr-2">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"/>
                                    </svg>
                                    J'aime
                                </div>)}
                        </button>
                    )}
                    {showPicker && (
                        <div className={'absolute bottom-full left-0'}>
                            <Picker
                                searchDisabled={true}
                                autoFocusSearch={false}
                                reactionsDefaultOpen={true}
                                allowExpandReactions={false}
                                lazyLoadEmojis={true}
                                emojiStyle={'native'}
                                className={"emojiPicker"}
                                onEmojiClick={(emojiObject) => sendReaction(emojiObject.emoji)}
                            />
                        </div>
                    )}
                </div>
                <div className={'px-3 bg-gray-100'}>
                    {showLikeButton && (
                        <button className={`flex items-center mx-auto emoji-button like_container`}
                                onClick={() => setShowCommentInput(!showCommentInput)}>
                            <div className={"likeLibelle__container"}>
                                <svg className="w-6 h-6 mr-1 dark:text-white" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                     viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M7 9h5m3 0h2M7 12h2m3 0h5M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.616a1 1 0 0 0-.67.257l-2.88 2.592A.5.5 0 0 1 8 18.477V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"/>
                                </svg>
                                Commenter
                            </div>
                        </button>
                    )}
                </div>
                {showCommentInput && (
                    <div className="mt-4 col-span-2">
                        <div className="flex items-center w-full">
                            <input
                                type="text"
                                placeholder="Écrire un commentaire..."
                                className="p-2 border rounded flex-grow"
                                value={newComment}
                                onChange={(e) => {
                                    if (e.target.value.length <= 191) {
                                        setNewComment(e.target.value);
                                    }
                                }}
                                maxLength="191"
                            />
                            <button
                                className="ml-2 p-2 bg-blue-500 text-white rounded"
                                onClick={handleAddComment}
                                style={{display: newComment.length === 0 ? 'none' : 'block'}}
                            >
                                <svg className="w-6 h-6 text-white dark:text-white" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     viewBox="0 0 24 24" transform="rotate(45)">
                                    <path fillRule="evenodd"
                                          d="M12 2a1 1 0 0 1 .932.638l7 18a1 1 0 0 1-1.326 1.281L13 19.517V13a1 1 0 1 0-2 0v6.517l-5.606 2.402a1 1 0 0 1-1.326-1.281l7-18A1 1 0 0 1 12 2Z"
                                          clipRule="evenodd"/>
                                </svg>
                            </button>
                        </div>
                        <div className="mt-4 nunito">
                            {coms.map((comment, index) => (
                                <div key={index} className="flex items-start p-4 border-b">
                                    {/*{ comment.user?.email === JSON.parse(widgetStore.getCookie("currentUserInfos")).email ? "MATCH"  : ''}*/}
                                    <div className="flex-shrink-0">
                                        <InitialeCircle name={comment.user?.nom + ' ' + comment.user?.prenom}/>
                                        {/*{comment.user?.nom.charAt(0).toUpperCase()}*/}
                                        {/*{comment.user?.prenom.charAt(0).toUpperCase()}*/}
                                    </div>
                                    <div className="ml-4">
                                        <div className="text-sm font-medium text-gray-900 flex items-center">
                                            {comment.user?.nom} {comment.user?.prenom}
                                            <span
                                                className={'text-xs font-thin text-gray-500 ml-2'}> - {convertTimeToReadableFormat(comment.updated_at)}</span>
                                            <div
                                                onClick={() => handleOpenModalCommentSuppression(comment.id)}
                                                className="ml-2"
                                                style={{display: comment.user?.email === JSON.parse(widgetStore.getCookie("currentUserInfos")).email ? "block" : "none"}}
                                            >
                                                <CorbeilleSvg/>
                                            </div>
                                        </div>
                                        <p className={'text-xs font-thin text-gray-500 mb-0'}>{comment.user?.fonction}</p>
                                        <div className="text-xs font-thin text-gray-500">
                                            {new Date(comment.updated_at).toLocaleString('fr-FR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </div>
                                        <EditableText
                                            text={comment.comment}
                                            onSave={(newText) => {
                                                axiosUserInstance.post(`/api/MI/UpdateComment/${id}/${widgetStore.idTotem}`, {
                                                    idComment: comment.id,
                                                    comment: newText
                                                })
                                                    .then((res) => {
                                                        console.log('Commentaire mis à jour:', newText);
                                                        // recupListMessagesInterServices();
                                                    })
                                                    .catch((err) => {
                                                        console.error('Erreur lors de la mise à jour du commentaire:', err);
                                                    });
                                            }}
                                        />
                                        {/*<div className="mt-1 text-sm text-gray-700">{comment.comment}</div>*/}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const postMessageInterServices = async (message) => {
        const whoAdd = totemList.find(totem => totem.id_totem === widgetStore.idTotem).tot_nom;

        let totemListToSend = [];
        totemList.forEach(totem => {
            if (message.includes(totem.id_totem)) {
                totemListToSend.push(totem.id_totem)
            }
        });
        totemListToSend.push(widgetStore.idTotem)

        const formData = new FormData();
        let file = null;

        // Si une image est sélectionnée, la convertir en fichier à envoyer.
        if (selectedImage) {
            // Convertir l'URL du blob en fichier
            const res = await fetch(selectedImage);
            const blob = await res.blob();
            file = new File([blob], `${uuidv4()}.png`, {type: 'image/png'});
            formData.append('image', file);
        }

        formData.append('title', title);
        formData.append('message', message);
        formData.append('is_pinned', pinned);
        formData.append('configurable_type', "MIMessage");
        formData.append('totems', JSON.stringify(totemListToSend));
        formData.append('whoAdd', whoAdd);
        if (bibliothequeImagesStore.selectedImageModule) {
            formData.append('imageBibliotheque', bibliothequeImagesStore.selectedImageModule)
        }
        messageInterServicesStore.sendMessagesInterServices(ent, widgetStore.idTotem, formData)
            .then((res) => {
                    recupListMessagesInterServices();
                    handleCloseModalAdd();
                    SetTitle("");
                    SetMessage("");
                    selectedImage && setSelectedImage(null);
                    bibliothequeImagesStore.onResetImageModule();
                    bibliothequeImagesStore.handleCloseAddPhoto();
                }
            );

    }

    const updateMessageInterServices = async (idConf) => {
        const whoAdd = totemList.find(totem => totem.id_totem === widgetStore.idTotem).tot_nom;

        let totemListToSend = [];
        totemList.forEach(totem => {
            if (message.includes(totem.id_totem)) {
                totemListToSend.push(totem.id_totem)
            }
        });
        totemListToSend.push(widgetStore.idTotem)

        const formData = new FormData();
        let file = null;

        // Si une image est sélectionnée, la convertir en fichier à envoyer.
        if (selectedUpdateImage) {
            // Convertir l'URL du blob en fichier
            const res = await fetch(selectedUpdateImage);
            const blob = await res.blob();
            file = new File([blob], `${uuidv4()}.png`, {type: 'image/png'});
            formData.append('image', file);
        }
        //datasUpdate.configurable.contenu
        formData.append('title', datasUpdate.title);
        formData.append('supprImg', datasUpdate.configurable?.messimage);
        formData.append('message', datasUpdate.configurable.contenu);
        formData.append('is_pinned', datasUpdate.isPinned);
        formData.append('configurable_type', "MIMessage");
        formData.append('totems', JSON.stringify(totemListToSend));
        formData.append('idConf', datasUpdate.idConf);
        if (bibliothequeImagesStore.selectedImageModule) {
            formData.append('imageBibliotheque', bibliothequeImagesStore.selectedImageModule)
        }

        // formData.append('whoAdd', whoAdd);
        messageInterServicesStore.sendUpdateMessagesInterServices(ent, widgetStore.idTotem, formData, datasUpdate.idConf)
            .then((res) => {
                    bibliothequeImagesStore.onResetImageModule();
                    bibliothequeImagesStore.handleCloseAddPhoto();
                    recupListMessagesInterServices();
                    messageInterServicesStore.showEdit = false;
                    setDatasUpdate({});
                    selectedUpdateImage && setSelectedUpdateImage(null);
                }
            );
    }

    //fonction qui ouvre une modal pour la confirmation de suppression
    const handleOpenModalSuppression = (id) => {
        setShowModalSuppr(true);
        messageInterServicesStore.idMessageToDelete = id;
    }
    const confirmSuppression = () => {
        messageInterServicesStore.deleteMessagesInterServices(ent, messageInterServicesStore.idMessageToDelete).then(() => {
            setShowModalSuppr(false);
            messageInterServicesStore.idMessageToDelete = null;
            recupListMessagesInterServicesArchives();
        });
    }

    const handleOpenModalCommentSuppression = (id) => {
        setShowModalSupprComment(true);
        messageInterServicesStore.idCommentToDelete = id;
    }

    const confirmSuppressionComment = () => {
        messageInterServicesStore.deleteCommentMessagesInterServices(ent, messageInterServicesStore.idCommentToDelete, widgetStore.idTotem).then(() => {
            setShowModalSupprComment(false);
            messageInterServicesStore.idCommentToDelete = null;
            recupListMessagesInterServicesArchives();
        });
    }

    return (
        <div className={"contentNiv1"}>
            <SidebarWidgets widget={"messagesInterService"}/>
            <div className={"MessagesInterServices"}>
                <h1 className={"headerSubtitle"}>Messages</h1>
                <div className={"titrePage"}>
                    Messages Internes
                </div>

                {/*'Modal de confirmation de suppression'*/}
                {showModalSuppr && (
                    <ModalPrimary
                        textTitle={"Êtes-vous sûr de vouloir supprimer ce message ?"}
                        textComment={""}
                        textBtnValidate={"Supprimer"}
                        textBtnCancel={"Annuler"}
                        onCancel={() => setShowModalSuppr(false)}
                        onValidate={() => confirmSuppression()}
                    />
                )}

                {showModalSupprComment && (
                    <ModalPrimary
                        textTitle={"Êtes-vous sûr de vouloir supprimer ce commentaire ?"}
                        textComment={""}
                        textBtnValidate={"Supprimer"}
                        textBtnCancel={"Annuler"}
                        onCancel={() => setShowModalSupprComment(false)}
                        onValidate={() => confirmSuppressionComment()}
                    />
                )}

                {listMessagesInterServices.length === 0 ? (
                    <div className={"aucunMessage"}>
                        Aucun message
                    </div>
                ) : (listMessagesInterServices.map((flux) => {
                    return (
                        <div className={"grid grid-cols-5"} key={flux.id}>

                            <div
                                // className="MessageIS portraiit:w-auto portrait:m-4 landscape:my-4 landscape:mx-auto landscape:w-1/2">
                                className="MessageIS col-span-4">
                                {/*<div className={"supprimer"} onClick={() => supprimerMIDuTotem(flux.id)}*/}
                                {/*     onTouchEnd={() => supprimerMIDuTotem(flux.id)}>*/}
                                {/*    <FontAwesomeIcon icon={faTimes}/>*/}
                                {/*</div>*/}
                                <PostHeader isPinned={flux.pivot.is_pinned} idConf={flux.id} title={flux.title}
                                            name={flux.created_by} createdAt={flux.created_at}
                                            configurable={flux.configurable}
                                            updatedAt={flux.updated_at}
                                            showDotsMenu={true}
                                />
                                {
                                    flux.configurable_type_min === "MIMessage" ? (
                                        <MIMessage className="MIMessage"
                                                   configurable={flux.configurable}></MIMessage>
                                    ) : flux.configurable_type_min === "MIMessimage" ? (
                                        <MIMessimage className="MIMessimage"
                                                     configurable={flux.configurable}></MIMessimage>
                                    ) : flux.configurable_type_min === "MIImage" ? (
                                        <MIImage className="MIImage" configurable={flux.configurable}></MIImage>
                                    ) : flux.configurable_type_min === "MIPdf" ? (
                                        <MIPdf className="MIPdf" configurable={flux.configurable}></MIPdf>
                                    ) : flux.configurable_type_min === "MIYoutube" ? (
                                        <MIYoutube className="MIYoutube"
                                                   configurable={flux.configurable}></MIYoutube>
                                    ) : (
                                        <div>Autre {flux.configurable_type_min}</div>
                                    )
                                }
                                <div className="validation_quarts">
                                    <span className={'title_validation_quart'}>Validation</span>
                                    <div className={'listesQuart'}>
                                        {flux.quarts.map((quart, key) => {
                                            return <Checkbox
                                                id_input={`${"quart_" + quart.id + "_validation_" + flux.id}`}
                                                onClick={() => toggleMISQuart(flux.id, quart.id)}
                                                checked={quart.pivot.date_validation !== null}
                                                label={quart.nom}/>
                                        })}
                                    </div>
                                </div>
                                <PostFooter id={flux.id} count={flux.reactions.length} reactions={flux.reactions}
                                            coms={flux.comments}/>
                            </div>
                            <div style={{margin: "2rem 1em"}}>
                            </div>
                        </div>
                    )
                }))}
            </div>
            {/*    </div>*/}
            {/*)}*/}
            {/* TIROIR AJOUT */}
            <div className={`${!messageInterServicesStore.showAdd && "hidden"} editContainer`}>
                <div className="edit__title">
                    Ajouter un nouveau message
                    <div className="float-right cursor-pointer"
                         onClick={() => messageInterServicesStore.handleCloseAdd()}
                         onTouchEnd={() => messageInterServicesStore.handleCloseAdd()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none">
                            <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                  strokeWidth="2"/>
                        </svg>
                    </div>
                </div>

                <div className={"mb-3"}>
                    {/*    epinglage*/}
                    <div className={'edit__content__pin mb-4'}>
                        <div className="grid grid-cols-3">
                            <div className={"edit__label"}>Epinglé :</div>
                            <div className={'col-span-2'}>
                                <label
                                    className="ml-0 inline-flex relative items-center cursor-pointer">
                                    <input type="checkbox" value=""
                                           id={`epingle`}
                                           className="sr-only peer"
                                           role="switch"
                                           onClick={() => setPinned(!pinned)}
                                           onTouchEnd={() => setPinned(!pinned)}
                                    />
                                    <div
                                        className="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4
                                                                        peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full
                                                                        peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5
                                                                        after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full
                                                                        after:h-6 after:w-6 after:transition-all peer-checked:bg-[#F8D541]"
                                    ></div>
                                </label>
                                <label
                                    htmlFor={`epingle`}
                                    className="ml-0 mr-3 nameQuart_validation"
                                >
                                    <svg
                                        // onClick={() => handleTogglePinned(idConf, widgetStore.idTotem)}
                                        className={'h-8 w-8'}
                                        xmlns="http://www.w3.org/2000/svg" width="14" height="19"
                                        viewBox="0 0 14 19"
                                        fill="none">
                                        <path
                                            d="M4.32261 3.44626L2.62905 1H11.2851L9.59149 3.44626V8.90332L12.4141 12.2905H1.5L4.32261 8.90332V3.44626Z"
                                            fill="#F8D541" stroke="#F8D541" strokeWidth="2"
                                            strokeLinejoin="round"/>
                                        <path
                                            d="M6.39258 17.1848V12.4805H7.7098V17.1848L7.14528 18.502L6.39258 17.1848Z"
                                            fill="#F8D541"/>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/*    message */}
                    <div className="edit__content__title mb-3">
                        <div className="grid grid-cols-3">
                            <div className={'edit__label'}>
                                Titre :
                            </div>
                            <div className={"edit__div_title col-span-2"}>
                                <input
                                    type="text"
                                    className={'border-1 border-black rounded  mb-3 w-[95%]'}
                                    placeholder={'Titre'}
                                    value={title}
                                    onChange={(e) => SetTitle(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="edit__content__message mb-3">
                            <div className="">
                                <div className={'edit__label mb-2'}>
                                    Message :<span className={"text-red-500 font-semibold"}>*</span>
                                </div>
                                <div>
                                    <MentionsInput
                                        id={'messageInput'}
                                        className={'border-1 border-black rounded p-0.5 mt-2 mb-2 mx-0'}
                                        value={message}
                                        onChange={(e) => SetMessage(e.target.value)}
                                        placeholder='De quoi souhaitez-vous discuter ? *'
                                        style={inputStyle}
                                    >

                                        <Mention
                                            className="bg-blue-200 rounded-lg py-0.5"
                                            trigger="@"
                                            style={{textDecoration: "underline #7148D7FF"}}
                                            data={totemList.map(totem => ({
                                                id: totem.id_totem,
                                                display: totem.tot_nom
                                            }))}
                                            renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
                                                <div className={`user ${focused ? 'focused' : ''}`}>
                                                    {highlightedDisplay}
                                                </div>
                                            )}
                                        />
                                    </MentionsInput>
                                    {errFormAdd.message && (
                                        <div
                                            className={`border-${errFormAdd.type === 'error' ? 'red' : 'green'}-200 bg-${errFormAdd.type === 'error' ? 'red' : 'green'}-100 text-${errFormAdd.type === 'error' ? 'red' : 'green'}-500 text-center`}>
                                            {errFormAdd.message}
                                        </div>
                                    )}
                                    {selectedImage || bibliothequeImagesStore.selectedImageModule ? (<>
                                        <button onClick={() => {
                                            setSelectedImage(null);
                                            bibliothequeImagesStore.onResetImageModule();
                                        }}
                                                className={`mb-2 float-right text-white bg-gray-600 p-2.5 ml-2 rounded-full hover:bg-gray-800`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M6 18 18 6M6 6l12 12"/>
                                            </svg>
                                        </button>

                                        {
                                            !bibliothequeImagesStore.selectedImageModule ? (
                                                <button onClick={() => document.getElementById('fileInput').click()}
                                                        className={`mb-2 float-right text-white bg-gray-600 p-2.5 ml-2 rounded-full hover:bg-gray-800`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                         viewBox="0 0 24 24"
                                                         strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"/>
                                                    </svg>
                                                </button>
                                            ) : null
                                        }


                                        {
                                            bibliothequeImagesStore.selectedImageModule ? (
                                                <img
                                                    src={process.env.REACT_APP_API_URL + "/uploads/bibliotheque/" + bibliothequeImagesStore.selectedImageModule}
                                                    alt="Selected" className={'rounded mb-2'}
                                                    style={{width: '100%', height: 'auto'}}/>
                                            ) : null
                                        }
                                        {
                                            selectedImage ? (
                                                <img src={selectedImage} alt="Selected" className={'rounded mb-2'}
                                                     style={{width: '100%', height: 'auto'}}/>
                                            ) : null
                                        }
                                    </>) : null}

                                    <input
                                        type="file"
                                        id="fileInput"
                                        style={{display: 'none'}}
                                        accept="image/*"
                                        onChange={handleImageChange}
                                    />

                                    <div className={"relative float-right mr-5 mb-4"} style={{display: 'flex'}}>
                                        <button onClick={() => SetEmojiPicker(!emojiPickerState)}
                                                className={`${emojiPickerState ? 'bg-gray-200' : 'text-gray-600'} p-2.5 mx-2 rounded-full hover:bg-gray-200`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 strokeWidth={1.5}
                                                 stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"/>
                                            </svg>
                                        </button>
                                        {!selectedImage && !bibliothequeImagesStore.selectedImageModule && (
                                            <>
                                                {hasBibliothequeImages && (
                                                    <button
                                                        onClick={() => {
                                                            bibliothequeImagesStore.handleOpenModuleImage();
                                                            sidebarWidgetStore.handleOpenSidebarWidget();
                                                        }}
                                                        className={`p-2.5 mx-2 rounded-full hover:bg-gray-200`}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             strokeWidth={1.5}
                                                             stroke="currentColor" className="w-6 h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
                                                        </svg>
                                                        Mes images
                                                    </button>
                                                )}
                                                <button
                                                    onClick={() => document.getElementById('fileInput').click()}
                                                    className={`p-2.5 mx-2 rounded-full hover:bg-gray-200`}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                         viewBox="0 0 24 24"
                                                         strokeWidth={1.5}
                                                         stroke="currentColor" className="w-6 h-6">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
                                                    </svg>
                                                    Importer une image
                                                </button>
                                            </>

                                        )}
                                        {emojiPicker}
                                    </div>
                                </div>
                            </div>
                            <div className="w-full inline-block">
                                <div className={"mx-5 float-right"}>
                                    <BtnPrimary
                                        // disabled={message.length === 0 || title.length > 50}

                                        className={"mx-5"}
                                        onClick={() => message.length > 0 && title.length <= 50 ?
                                            postMessageInterServices(message)
                                            :
                                            setErrFormAdd({
                                                type: 'error',
                                                message: title.length > 50 ? 'Le titre ne doit pas dépasser 50 caractères.' : 'Le message ne doit pas être vide.'
                                            })
                                        }
                                        onTouchEnd={() => message.length > 0 && title.length <= 50 ?
                                            postMessageInterServices(message)
                                            :
                                            setErrFormAdd({
                                                type: 'error',
                                                message: title.length > 50 ? 'Le titre ne doit pas dépasser 50 caractères.' : 'Le message ne doit pas être vide.'
                                            })}>
                                        Ajouter
                                    </BtnPrimary>
                                </div>
                                <div className={"float-right"}>
                                    <BtnSecondary onClick={handleCloseModalAdd}
                                                  onTouchEnd={handleCloseModalAdd}>
                                        Annuler
                                    </BtnSecondary>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* TIROIR ARCHIVE */}
            <div
                className={`${!messageInterServicesStore.showArchive && "hidden"} MessagesInterServices editContainer`}>
                <div className="edit__title">
                    Messages Archivés
                    <div className="float-right cursor-pointer"
                         onClick={() => messageInterServicesStore.handleCloseArchive()}
                         onTouchEnd={() => messageInterServicesStore.handleCloseArchive()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none">
                            <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                  strokeWidth="2"/>
                        </svg>
                    </div>
                </div>
                {
                    listMessagesInterServicesArchives.length === 0 ? (
                        <div className={"aucunMessage"}>Il n'y a aucun message</div>
                    ) : (listMessagesInterServicesArchives.map((flux) => {
                        return (
                            <div className={"grid grid-cols-5"} key={flux.id}>
                                <div className={'MIArchiveActions col-span-5'}>
                                    <button
                                        type="button"
                                        className={"MISupprArch"}
                                        aria-label={`Supprimer le message archivé ${flux.title}`}
                                        onClick={() => handleOpenModalSuppression(flux.id)}
                                    >
                                        <CorbeilleSvg/>
                                    </button>
                                    <button
                                        type="button"
                                        className={"MIrestaurer"}
                                        onClick={() => restaurerMIDuTotem(flux.id)}
                                    >
                                        restaurer
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             viewBox="0 0 24 24" fill="none">
                                            <path d="M9.7168 5L2.99972 12L9.7168 19" stroke="#70787B"
                                                  strokeWidth="2"/>
                                            <line y1="-1" x2="17.7331" y2="-1"
                                                  transform="matrix(1 0 0 -1 3.26758 11.0312)" stroke="#70787B"
                                                  strokeWidth="2"/>
                                        </svg>
                                    </button>
                                </div>
                                <div className="MessageIS col-span-5">
                                    <PostHeader isPinned={flux.pivot.is_pinned} idConf={flux.id}
                                                title={flux.title}
                                                name={flux.created_by} createdAt={flux.created_at}
                                                configurable={flux.configurable}
                                                updatedAt={flux.updated_at}/>
                                    {
                                        flux.configurable_type_min === "MIMessage" ? (
                                            <MIMessage className="MIMessage"
                                                       configurable={flux.configurable}></MIMessage>
                                        ) : flux.configurable_type_min === "MIMessimage" ? (
                                            <MIMessimage className="MIMessimage"
                                                         configurable={flux.configurable}></MIMessimage>
                                        ) : flux.configurable_type_min === "MIImage" ? (
                                            <MIImage className="MIImage"
                                                     configurable={flux.configurable}></MIImage>
                                        ) : flux.configurable_type_min === "MIPdf" ? (
                                            <MIPdf className="MIPdf" configurable={flux.configurable}></MIPdf>
                                        ) : flux.configurable_type_min === "MIYoutube" ? (
                                            <MIYoutube className="MIYoutube"
                                                       configurable={flux.configurable}></MIYoutube>
                                        ) : (
                                            <div>Autre {flux.configurable_type_min}</div>
                                        )
                                    }
                                    <PostFooter
                                        id={flux.id}
                                        count={flux.reactions.length}
                                        reactions={flux.reactions}
                                        showLikeButton={!messageInterServicesStore.showArchive}
                                    />


                                </div>
                            </div>
                        )
                    }))}
            </div>
            {/*  TIROIR EDIT  */}
            <div className={`${!showUpdate && "hidden"} editContainer`}>
                <div className="edit">
                    <div className="edit__container">
                        <div className="edit__title">
                            Modifier le message
                            <div className="float-right cursor-pointer"
                                 onClick={() => messageInterServicesStore.showEdit = false}
                                 onTouchEnd={() => messageInterServicesStore.showEdit = false}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                          strokeWidth="2"/>
                                    <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                          strokeWidth="2"/>
                                    <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                          strokeWidth="2"/>
                                </svg>
                            </div>
                        </div>
                        <div className="edit__content">
                            <div className="edit__content__date mb-4">
                                <div className="grid grid-cols-3">
                                    <div className={'edit__label'}>
                                        Date :
                                    </div>
                                    <div className={"edit__date col-span-2"}>
                                        {datasUpdate?.formattedDate}
                                    </div>
                                </div>
                            </div>
                            <div className={'edit__content__pin mb-4'}>
                                <div className="grid grid-cols-3">
                                    <div className={"edit__label"}>Epinglé :</div>
                                    <div className={'col-span-2'}>
                                        <label
                                            className="ml-0 inline-flex relative items-center cursor-pointer">
                                            <input type="checkbox" value={"epingle"}
                                                   id={`epingle`}
                                                   className="sr-only peer "
                                                   role="switch"
                                                   onClick={(e) => setDatasUpdate({
                                                       ...datasUpdate,
                                                       isPinned: e.target.checked
                                                   })}
                                                   onTouchEnd={(e) => setDatasUpdate({
                                                       ...datasUpdate,
                                                       isPinned: e.target.checked
                                                   })}
                                                   checked={datasUpdate?.isPinned}
                                            />
                                            <div
                                                className="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4
                                                                        peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full
                                                                        peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5
                                                                        after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full
                                                                        after:h-6 after:w-6 after:transition-all peer-checked:bg-[#F8D541]"
                                            ></div>
                                        </label>
                                        <label
                                            htmlFor={`epingle`}
                                            className="ml-0 mr-3 nameQuart_validation"
                                        >
                                            <svg
                                                // onClick={() => handleTogglePinned(idConf, widgetStore.idTotem)}
                                                className={'h-8 w-8'}
                                                xmlns="http://www.w3.org/2000/svg" width="14" height="19"
                                                viewBox="0 0 14 19"
                                                fill="none">
                                                <path
                                                    d="M4.32261 3.44626L2.62905 1H11.2851L9.59149 3.44626V8.90332L12.4141 12.2905H1.5L4.32261 8.90332V3.44626Z"
                                                    fill="#F8D541" stroke="#F8D541" strokeWidth="2"
                                                    strokeLinejoin="round"/>
                                                <path
                                                    d="M6.39258 17.1848V12.4805H7.7098V17.1848L7.14528 18.502L6.39258 17.1848Z"
                                                    fill="#F8D541"/>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="edit__content__title mb-3">
                                <div className="grid grid-cols-3">
                                    <div className={'edit__label'}>
                                        Titre :
                                    </div>
                                    <div className={"edit__div_title col-span-2"}>
                                        <input type="text" value={datasUpdate?.title}
                                               onChange={(e) => setDatasUpdate({
                                                   ...datasUpdate,
                                                   title: e.target.value
                                               })}
                                               className="edit__content__title__input border-1 border-black rounded  mb-3 w-[95%]"
                                               placeholder="Titre du message"/>
                                    </div>
                                </div>

                            </div>
                            <div className="edit__content__message mb-3">
                                <div className="">
                                    <div className={'edit__label mb-2'}>
                                        Message :<span className={"text-red-500 font-semibold"}>*</span>
                                    </div>
                                    <div>
                                        <MentionsInput
                                            id={'messageInputUpdate'}
                                            className={'border-1 border-black rounded p-0.5 mt-2 mb-2 mx-0'}
                                            value={datasUpdate?.configurable?.contenu}
                                            onChange={(e) => setDatasUpdate({
                                                ...datasUpdate,
                                                configurable: {
                                                    ...datasUpdate.configurable,
                                                    contenu: e.target.value
                                                }
                                            })}
                                            placeholder='De quoi souhaitez-vous discuter ? *'
                                            style={inputStyle}
                                        >

                                            <Mention
                                                className="bg-blue-200 rounded-lg py-0.5"
                                                trigger="@"
                                                style={{textDecoration: "underline #7148D7FF"}}
                                                data={totemList.map(totem => ({
                                                    id: totem.id_totem,
                                                    display: totem.tot_nom
                                                }))}
                                                renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
                                                    <div className={`user ${focused ? 'focused' : ''}`}>
                                                        {highlightedDisplay}
                                                    </div>
                                                )}
                                            />
                                        </MentionsInput>
                                        {errFormAdd.message && (
                                            <div
                                                className={`border-${errFormAdd.type === 'error' ? 'red' : 'green'}-200 bg-${errFormAdd.type === 'error' ? 'red' : 'green'}-100 text-${errFormAdd.type === 'error' ? 'red' : 'green'}-500 text-center`}>
                                                {errFormAdd.message}
                                            </div>
                                        )}
                                        {selectedUpdateImage || bibliothequeImagesStore.selectedImageModule ? (<>
                                            <button
                                                onClick={() => {
                                                    setSelectedUpdateImage(null);
                                                    document.getElementById('fileInputUpdate').value = null;
                                                    bibliothequeImagesStore.onResetImageModule();
                                                }}
                                                className={`mb-2 float-right text-white bg-gray-600 p-2.5 ml-2 rounded-full hover:bg-gray-800`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                     strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                    <path strokeLinecap="round" strokeLinejoin="round"
                                                          d="M6 18 18 6M6 6l12 12"/>
                                                </svg>
                                            </button>
                                            {
                                                !bibliothequeImagesStore.selectedImageModule ? (
                                                    <button
                                                        onClick={() => document.getElementById('fileInputUpdate').click()}
                                                        className={`mb-2 float-right text-white bg-gray-600 p-2.5 ml-2 rounded-full hover:bg-gray-800`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             strokeWidth={1.5} stroke="currentColor"
                                                             className="w-4 h-4">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"/>
                                                        </svg>
                                                    </button>
                                                ) : null
                                            }


                                            {
                                                bibliothequeImagesStore.selectedImageModule ? (
                                                    <img
                                                        src={process.env.REACT_APP_API_URL + "/uploads/bibliotheque/" + bibliothequeImagesStore.selectedImageModule}
                                                        alt="Selected" className={'rounded mb-2'}
                                                        style={{width: '100%', height: 'auto'}}/>
                                                ) : null
                                            }
                                            {
                                                selectedUpdateImage ? (
                                                    <img src={selectedUpdateImage} alt="Selected"
                                                         className={'rounded mb-2'}
                                                         style={{width: '100%', height: 'auto'}}/>
                                                ) : null
                                            }
                                        </>) : null}


                                        {!selectedUpdateImage && (datasUpdate.configurable?.messimage && datasUpdate.configurable?.messimage !== ' ') && (
                                            <>
                                                <button
                                                    onClick={() => {
                                                        // datasUpdate.configurable.messimage = ''' in setDatasUpdated
                                                        setDatasUpdate({
                                                            ...datasUpdate,
                                                            configurable: {
                                                                ...datasUpdate.configurable,
                                                                messimage: ' '
                                                            }
                                                        });
                                                    }}
                                                    className={`mb-2 float-right text-white bg-gray-600 p-2.5 ml-2 rounded-full hover:bg-gray-800`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                         viewBox="0 0 24 24"
                                                         strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              d="M6 18 18 6M6 6l12 12"/>
                                                    </svg>
                                                </button>
                                                <img
                                                    src={process.env.REACT_APP_API_URL + "/" + datasUpdate.configurable.messimage}
                                                    alt="Selected"
                                                    className={'rounded mb-2'}
                                                    style={{width: '100%', height: 'auto'}}/>
                                            </>
                                        )}


                                        <input
                                            type="file"
                                            id="fileInputUpdate"
                                            style={{display: 'none'}}
                                            accept="image/*"
                                            onChange={handleImageUpdateChange}
                                        />

                                        <div className={"relative float-right mr-5 mb-4"} style={{display: 'flex'}}>
                                            <button onClick={() => SetEmojiPicker(!emojiPickerState)}
                                                    className={`${emojiPickerState ? 'bg-gray-200' : 'text-gray-600'} p-2.5 mx-2 rounded-full hover:bg-gray-200`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                     strokeWidth={1.5}
                                                     stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round"
                                                          d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"/>
                                                </svg>
                                            </button>
                                            {!selectedUpdateImage && (!datasUpdate.configurable?.messimage || datasUpdate.configurable?.messimage === ' ') && !bibliothequeImagesStore.selectedImageModule && (
                                                <>
                                                    <button
                                                        onClick={() => {
                                                            bibliothequeImagesStore.handleOpenModuleImage();
                                                            sidebarWidgetStore.handleOpenSidebarWidget();
                                                        }}
                                                        className={`p-2.5 mx-2 rounded-full hover:bg-gray-200`}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             strokeWidth={1.5}
                                                             stroke="currentColor" className="w-6 h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
                                                        </svg>
                                                        Mes images
                                                    </button>
                                                    <button
                                                        onClick={() => document.getElementById('fileInputUpdate').click()}
                                                        className={`p-2.5 mx-2 rounded-full hover:bg-gray-200`}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             strokeWidth={1.5}
                                                             stroke="currentColor" className="w-6 h-6">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
                                                        </svg>
                                                        Importer une image
                                                    </button>
                                                </>
                                            )}
                                            {emojiPickerUpdate}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="edit__content__buttons">
                                <div className="w-full inline-block">
                                    <div className={"mx-5 float-right"}>
                                        <BtnPrimary
                                            // disabled={message.length === 0 || title.length > 50}

                                            className={"mx-5"}
                                            onClick={() => datasUpdate.configurable.contenu?.length > 0 && (datasUpdate.title?.length <= 50 || !datasUpdate.title) ?
                                                updateMessageInterServices()
                                                :
                                                setErrFormAdd({
                                                    type: 'error',
                                                    message: datasUpdate.title?.length > 50 ? 'Le titre ne doit pas dépasser 50 caractères.' : 'Le message ne doit pas être vide.'
                                                })
                                            }
                                            onTouchEnd={() => datasUpdate.configurable.contenu?.length > 0 && (datasUpdate.title?.length <= 50 || !datasUpdate.title) ?
                                                updateMessageInterServices()
                                                :
                                                setErrFormAdd({
                                                    type: 'error',
                                                    message: datasUpdate.title?.length > 50 ? 'Le titre ne doit pas dépasser 50 caractères.' : 'Le message ne doit pas être vide.'
                                                })}>
                                            Valider
                                        </BtnPrimary>
                                    </div>
                                    <div className={"float-right"}>
                                        <BtnSecondary onClick={() => {
                                            messageInterServicesStore.showEdit = false;
                                            bibliothequeImagesStore.onResetImageModule();
                                            bibliothequeImagesStore.handleCloseModuleImage();
                                        }}
                                                      onTouchEnd={() => {
                                                          messageInterServicesStore.showEdit = false;
                                                          bibliothequeImagesStore.onResetImageModule();
                                                          bibliothequeImagesStore.handleCloseModuleImage();
                                                      }}
                                        >
                                            Fermer
                                        </BtnSecondary>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*  FIN  */}
        </div>
    );
});

export default ListeMessagesInterServices;
